export default {
  state: {
    visibility: true
  },
  mutations: {
    SET_RIGHT_BAR_VISIBILITY(state, payload) {
      state.visibility = payload === 'toggle' ? !state.visibility : payload
    }
  }
}
